import React, { useContext, useEffect, useReducer, useState, useMemo } from 'react'
import {
    Box, Select, FormControl, InputLabel, MenuItem, Autocomplete, Alert,
    Dialog, DialogActions, DialogContent, DialogTitle, Divider, Button, FormGroup,
    FormControlLabel, Checkbox, TextField
} from '@mui/material'
import { JourneyContext } from '../kanban'
import api from '../../../api'
import Loading from '../../Loading'
import { alphabeticalSort } from '../../../utils/alphabeticalSort'
import { SendEmailContent } from '../../Crm/TabButtons/SendMessage/SendEmail'
import { getSession } from '../../../auth'
import Typography from '../../Typography'
import { WhatsappSelect, matchRegLen, ParamModal } from '../../Crm/CreateCampaignModal'
import { lockedReducer } from '../../../utils/defaultReducer'
import ParameterFiller from '../../Crm/Templates/ParameterFiller'
import { getAttachments } from '../../Chat/MessagesArea/ChatWindow/MessageItem'
import { Description } from '@mui/icons-material'
import MuiTypography from '@mui/material/Typography'

export const EditOptions = {
    '': '',
    'MOVE': 'Mover Oportunidade',
    'COPY': 'Copiar Oportunidade',
    'ARCHIVE': 'Arquivar Oportunidade',
    'DELETE': 'Apagar Oportunidade',
    'STATUS': 'Alterar Status'
}

export const StatusOptions = {
    'ACTIVE': 'Ativa',
    'INACTIVE': 'Inativa',
    'QUALIFIED': 'Qualificada',
    'CONQUERED': 'Conquistada',
    'LOST': 'Perdida'
}


export const ContactOptions = {
    '': '',
    'WHATSAPP': 'Whatsapp',
    'EMAIL': 'E-mail',
    'VOICE': 'Voz'
}

const handleSelectedTemplate = (template, setState, setParent) => {
    setParent({parameters: [], mediaParameters: {}})

    if (!template) return
    const requiredParameters = []
    if (template.components.length == 1 && template.components[0].type == 'BODY') {
        let amount = matchRegLen(template.components[0].text)
        if (amount)
            requiredParameters.push(
                {
                    type: 'BODY',
                    amount: amount
                }
            )
    }
    else {
        template.components.map(component => {
            let amount = 0
            if (component.type == 'HEADER') {
                amount = 1
                if (component.format == 'TEXT')
                    amount = matchRegLen(component.text)
                if (amount)
                    requiredParameters.push({
                        type: component.type,
                        format: component.format,
                        amount: amount
                    })
            }
            else if (component.type == 'BODY') {
                amount = matchRegLen(component.text)
                if (amount)
                    requiredParameters.push(
                        {
                            type: 'BODY',
                            amount: amount
                        }
                    )
            }

            else if (component.type == 'BUTTONS') {
                amount = 0
                component.buttons.map(button => {
                    if (button.type === 'URL')
                        amount += matchRegLen(button.url)
                })
                if (amount)
                    requiredParameters.push(
                        {
                            type: 'BUTTONS',
                            amount: amount
                        }
                    )
            }

        })
    }

    if (requiredParameters.length > 0) {
        setParent({
            template: template,
            parameters: requiredParameters
        })
        setState({ paramModal: true })
        return
    }
    setParent({ template: template })

}

const handleNumberChange = (number, oldtemplates, setState, setParent) => {

    if (getSession().profile.enterprise.abstraction_layer) {
        setState({ loading: true })
        const enterpriseId = getSession().profile.enterprise.id
        const digits = number?.replace(/\D/g, '');
        if (!digits) return
        return api.get(`api/enterprises/${enterpriseId}/templates/${digits}/`)
            .then((res) => {
                const templates = res.data.waba_templates.filter((t) => t.status.toLowerCase() === 'approved')
                if (res.status === 200) {
                    setState({
                        loading: false,
                        templates: templates
                    })
                    setParent({ sender: number })
                    return templates
                }
                throw err
            })
            .catch((err) => { setState({ loading: false }) })
    } else {
        setState({ loading: false })
        setParent({ sender: number })
        return oldtemplates
    }
}

const WhatsappSubSelect = ({ parent, setParent, opportunityCustomFields = null }) => {

    const [state, setState] = useReducer(lockedReducer, {
        senders: [],
        templates: [],
        queues: [],
        paramModal: false,
        allParamsFilled: false,
        loading: false
    })

    useEffect(() => {
        const initialize = async () => {
            let numbers = []
            const result = {loading: false}
            const enterprise = getSession().profile.enterprise
            setState({loading: true})
            const [instantresponse, metaresponse, queues] = await Promise.all([
                api.get(`/api/IS/account/${enterprise.accountcode}/senders/`, { timeout: 0 }),
                api.get(`/api/enterprises/${enterprise.id}/whatsapp/`),
                api.get(`/api/enterprises/${enterprise.id}/queues/chat/`),
            ])

            if (instantresponse.status === 200)
                numbers.push(...instantresponse.data)
            if (metaresponse.status === 200) 
                numbers.push(...metaresponse.data.map(each => each.phone_number))
            if (queues.status === 200) 
                result.queues = queues.data.map(queue => ({description: queue.description, name: (queue.name || '').split('_').pop()}))
            
            result.senders = numbers

            setState(result)
            if (parent.sender)
                handleNumberChange(parent.sender, parent.templates, setState, setParent)
        }; initialize()
    }, [])

    return (
        <>
        <Loading loading={state.loading} /> 
            <WhatsappSelect
                selectedSender={parent.sender}
                handleNumberChange={(number) => handleNumberChange(number, state.templates, setState, setParent)}
                senders={state.senders}
                filteredTemplates={state.templates}
                selectedTemplate={parent.template}
                handleSelectedTemplate={(template) => handleSelectedTemplate(template, setState, setParent)}
                mediaParameters={parent.mediaParameters}
                queues={state.queues}
                selectedQueue={parent.queue}
                handleSelectQueue={({target}) => setParent({queue: target.value})}
            />
            {state.paramModal &&
                <ParamModal
                    selectedTemplate={parent.template}
                    parameters={parent.parameters}
                    mediaParameters={parent.mediaParameters}
                    handleParamGoBack={() => { setState({ paramModal: false }); setParent({template: '', parameters: {}}) }}
                    updateParamModal={(data) => setState({paramModal: data})}
                    allParamsFilled={state.allParamsFilled}
                    setUpdateButtons={()=>{}}
                    checkParameters={(data) => {setState({allParamsFilled:data})}}
                    opportunityCustomFields={opportunityCustomFields}

                />}
        </>
    )
}

const VoiceCampaignSelect = ({ parent, setParent }) => {

    const [campaigns, setCampaigns] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const initialize = async () => {
            setLoading(true)
            const enterpriseId = getSession().profile.enterprise.id
            const res = await api.get(`api/enterprises/${enterpriseId}/campaign/voice_continuous_campaigns/`)
            if (res.status === 200)
                setCampaigns(res.data)
            setLoading(false)
        }; initialize()
    }, [])

    return (
        <>
            <FormControl size='small' fullWidth>
                <InputLabel id='select-voice-campaign'>Campanha de voz</InputLabel>
                <Select
                    labelId='select-voice-campaign'
                    label='Campanha de voz'
                    value={parent.campaign || ''}
                    onChange={({ target }) => {
                        setParent({ campaign: target.value })
                    }}
                >
                    {campaigns.map((campaign) => (
                        <MenuItem key={campaign.id} value={campaign.id}>{campaign.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            {!loading && campaigns.length === 0 &&
                <Alert severity="info">
                    Nenhuma campanha de voz contínua disponível. Crie uma campanha de voz do tipo Contínua no CRM antes de configurar esta automação.
                </Alert>
            }
        </>
    )
}

const REACTION_ACTIONS = {
    NONE: 'Nenhuma ação',
    ARCHIVE: 'Arquivar',
    DELETE: 'Apagar',
}

// RF04 fala em máximo 50 semanas; RN05 fala “sem limite” para tempo. Eu implementei com teto por segurança.
// Se quiser “sem limite”, remove os max que deseja.
const REACTION_PERIODS = {
    HOURS: { label: 'Horas', min: 1, max: 24 * 7 * 50 },     // 50 semanas
    DAYS: { label: 'Dias', min: 1, max: 7 * 50 },            // 50 semanas
    WORKDAYS: { label: 'Dias úteis', min: 1, max: 7 * 50 },  // 50 semanas
    WEEKS: { label: 'Semanas', min: 1, max: 50 },            // 50 semanas
}

const VOICE_REACTION_OUTCOMES = [
    { key: 'answered', label: 'Atendida' },
    { key: 'not_answered', label: 'Não atendida' },
    { key: 'busy', label: 'Ocupada' },
    { key: 'failed', label: 'Falha' },
]

const ensureVoiceReactionsShape = (reactions) => {
    const result = {}
    VOICE_REACTION_OUTCOMES.forEach(({ key }) => {
        result[key] = { action: 'NONE', destination: null, ...(reactions?.[key] || {}) }
    })
    return result
}

const ensureReactionsShape = (reactions) => {
    const base = {
        replied: { action: 'NONE', destination: null },
        no_reply: { action: 'NONE', destination: null, time: '', type: 'HOURS' },
        failed: { action: 'NONE', destination: null },
    }

    return {
        replied: { ...base.replied, ...(reactions?.replied || {}) },
        no_reply: { ...base.no_reply, ...(reactions?.no_reply || {}) },
        failed: { ...base.failed, ...(reactions?.failed || {}) },
    }
}


const getSelectValue = (reaction) => {
    if (!reaction || !reaction.action) return 'NONE'
    if (reaction.action === 'NONE') return 'NONE'
    if (reaction.action === 'MOVE') return reaction.destination != null ? String(reaction.destination) : 'NONE'
    return reaction.action // ARCHIVE | DELETE
}

// value pode ser: '' | 'ARCHIVE' | 'DELETE' | '<columnId>'
const applySelectValue = (value, prevReaction) => {
    const next = { ...(prevReaction || {}) }

    if (value === 'NONE' || value == null) {
        next.action = 'NONE'
        next.destination = null
        return next
    }

    if (value === 'ARCHIVE' || value === 'DELETE') {
        next.action = value
        next.destination = null
        return next
    }

    const colId = Number(value)
    next.action = 'MOVE'
    next.destination = Number.isFinite(colId) ? colId : null
    return next
}



export const ContactType = ({ columnId, parent, setParent, opportunityCustomFields = null }) => {

    const { board } = useContext(JourneyContext)

    const [emailTemplates, setEmailTemplates] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    
    const showReactions = parent.type === 'WHATSAPP' || parent.type === 'EMAIL'
    const reactions = ensureReactionsShape(parent.reactions)
    const showVoiceReactions = parent.type === 'VOICE'
    const voiceReactions = ensureVoiceReactionsShape(parent.reactions)

    const availableColumns = (board?.columns || []).filter(c => c.id !== columnId)

    const fetchEmailTemplates = async (data) => {
        const enterpriseId = getSession().profile.enterprise.id;

        const response = await api.get(
            `api/enterprises/${enterpriseId}/email_templates/`
        );

        if (response.status === 200) {
            const templates = response.data;

            setEmailTemplates(templates);

            const template = templates.find(
                (item) => String(item.id) === String(data.email_template_id)
            );

            setSelectedTemplate(template || null);
        }
    };

    useEffect(() => {
        if (parent.emailMessageData) {

            const attachmentregex = /\(emailattachment\)([\s\S]*?)\(\/emailattachment\)/g
            const data = parent
            const attachments_obj = getAttachments(attachmentregex, data.emailMessageData.bodyTextContent)
            data.emailMessageData.bodyTextContent = attachments_obj.response
            data.emailMessageData.attachments = [...attachments_obj.data.map(each => ({ ...each, loaded: true })), ...(data.emailMessageData.attachments || [])]

            if ('setEmailData' in window)
                window.setEmailData(data.emailMessageData)
        }

        fetchEmailTemplates(parent)
    }, [])

    const handleEmailTemplateChange = (templateId) => {
        if (!templateId) {
            setSelectedTemplate(null);
            setParent({
                email_template_id: null,
                subject: '',
            });

            if (typeof window.setCleanEmailPredefinedMessage === 'function') {
                window.setCleanEmailPredefinedMessage('');
            }

            return;
        }

        const template = emailTemplates.find(
            (item) => String(item.id) === String(templateId)
        );

        if (!template) return;

        setSelectedTemplate(template);

        const subject = template.subject || '';
        let content = template.html_content || '';

        if (template.content_type === 'text') {
            content = content
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/\r\n|\r|\n/g, '<br>');
        }

        setParent({
            email_template_id: template.id,
            subject,
        });

        if (typeof window.setCleanEmailPredefinedMessage === 'function') {
            window.setCleanEmailPredefinedMessage(content);
        }
    };

    return (
        <>
            <FormControl size='small' fullWidth>
                <InputLabel id='select-type-data'>Tipo</InputLabel>
                <Select
                    labelId='select-type-data'
                    label='Tipo'
                    value={parent.type}
                    onChange={({ target }) => {
                        const nextType = target.value
                        const patch = { type: nextType }

                        if (['WHATSAPP', 'EMAIL'].includes(nextType)) {
                            patch.reactions = ensureReactionsShape(parent.reactions)
                        }
                        if (nextType === 'VOICE') {
                            patch.reactions = ensureVoiceReactionsShape(parent.reactions)
                        }

                        setParent(patch)
                    }}
                >
                    {Object.entries(ContactOptions).flatMap(([key, value]) => {
                        if (key === '') return []
                        return (<MenuItem value={key}>{value}</MenuItem>)
                    }
                    )}
                </Select>
            </FormControl>
            <Box sx={{ gap: '.5rem', display: 'flex', flexDirection: 'column', maxHeight: '23rem', overflowY: 'auto' }}>
                {parent.type === 'WHATSAPP' && <>
                    <WhatsappSubSelect parent={parent} setParent={setParent} opportunityCustomFields={opportunityCustomFields} />
                </>}
                {parent.type === 'EMAIL' &&
                    <SendEmailContent
                        setLoading={() => { }}
                        parent={parent}
                        setParent={setParent}
                        queues={[]}
                        opportunityCustomFields={opportunityCustomFields}
                        emailMessageData={(data) => { parent.emailMessageData = data }}
                        canCopy={true}
                        emailTemplates={emailTemplates}
                        selectedTemplate={selectedTemplate}
                        onEmailTemplateChange={handleEmailTemplateChange}
                    />
                }
                {parent.type === 'VOICE' && <>
                    <VoiceCampaignSelect parent={parent} setParent={setParent} />
                </>}
                {showReactions && (
                    <Box sx={{ mt: 1 }}>
                        <Divider sx={{ mb: 1 }} />
                        <MuiTypography variant="h6" gutterBottom className="typography-title">
                            Reações após o disparo
                        </MuiTypography>

                        {/* 1) Quando responder */}
                        <Box sx={{ mt: 1 }}>
                            <MuiTypography variant="subtitle2" sx={{ mt: 1, fontWeight: 600 }}>
                                Quando o lead responder:
                            </MuiTypography>
                            <FormControl size="small" fullWidth sx={{ mt: 1.5 }}>
                                <InputLabel id="reaction-replied">Ação</InputLabel>
                                <Select
                                    labelId="reaction-replied"
                                    label="Ação"
                                    value={getSelectValue(reactions.replied)}
                                    onChange={({ target }) => {
                                        const nextReactions = ensureReactionsShape(parent.reactions)
                                        nextReactions.replied = applySelectValue(target.value, nextReactions.replied)
                                        setParent({ reactions: nextReactions })
                                    }}
                                >
                                    <MenuItem value="NONE">Nenhuma ação</MenuItem>
                                    <Divider />
                                    {availableColumns.map(col => (
                                        <MenuItem key={col.id} value={String(col.id)}>{col.title}</MenuItem>
                                    ))}
                                    <Divider />
                                    <MenuItem value="ARCHIVE">Arquivar</MenuItem>
                                    <MenuItem value="DELETE">Apagar</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        {/* 2) Quando não responder */}
                        <Box sx={{ mt: 2 }}>
                            <MuiTypography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
                                Quando o lead não responder:
                            </MuiTypography>

                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'left', mt: 1.5 }}>
                                <TextField
                                    size="small"
                                    type="number"
                                    placeholder=""
                                    label="Em"
                                    value={reactions.no_reply.time}
                                    disabled={reactions.no_reply.action === 'NONE'}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={({ target }) => {
                                        const nextReactions = ensureReactionsShape(parent.reactions)
                                        const t = target.value === '' ? '' : Math.max(1, parseInt(target.value, 10) || 1)
                                        nextReactions.no_reply.time = t
                                        setParent({ reactions: nextReactions })
                                    }}
                                    inputProps={{
                                        min: REACTION_PERIODS[reactions.no_reply.type || 'HOURS'].min,
                                        max: REACTION_PERIODS[reactions.no_reply.type || 'HOURS'].max,
                                    }}
                                    sx={{ width: 110 }}
                                />

                                <FormControl size="small" sx={{ minWidth: 140 }} disabled={reactions.no_reply.action === 'NONE'}>
                                    <InputLabel id="reaction-no-reply-unit">Unidade</InputLabel>
                                    <Select
                                        labelId="reaction-no-reply-unit"
                                        label="Unidade"
                                        value={reactions.no_reply.type || 'HOURS'}
                                        onChange={({ target }) => {
                                            const nextReactions = ensureReactionsShape(parent.reactions)
                                            nextReactions.no_reply.type = target.value
                                            setParent({ reactions: nextReactions })
                                        }}
                                    >
                                        {Object.entries(REACTION_PERIODS).map(([k, v]) => (
                                            <MenuItem key={k} value={k}>{v.label}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <FormControl size="small" fullWidth>
                                    <InputLabel id="reaction-no-reply-action">Ação</InputLabel>
                                    <Select
                                        labelId="reaction-no-reply-action"
                                        label="Ação"
                                        value={getSelectValue(reactions.no_reply)}
                                        onChange={({ target }) => {
                                            const nextReactions = ensureReactionsShape(parent.reactions)
                                            nextReactions.no_reply = applySelectValue(target.value, nextReactions.no_reply)

                                            // PRD: quando habilitar (ação != nenhuma), default 1 hora; quando voltar p/ nenhuma, limpar e desabilitar.
                                            if (nextReactions.no_reply.action === 'NONE') {
                                                nextReactions.no_reply.time = ''
                                                nextReactions.no_reply.type = 'HOURS'
                                            } else {
                                                if (!nextReactions.no_reply.time) nextReactions.no_reply.time = 1
                                                if (!nextReactions.no_reply.type) nextReactions.no_reply.type = 'HOURS'
                                            }

                                            setParent({ reactions: nextReactions })
                                        }}
                                    >
                                        <MenuItem value="NONE">Nenhuma ação</MenuItem>
                                        <Divider />
                                        {availableColumns.map(col => (
                                            <MenuItem key={col.id} value={String(col.id)}>{col.title}</MenuItem>
                                        ))}
                                        <Divider />
                                        <MenuItem value="ARCHIVE">Arquivar</MenuItem>
                                        <MenuItem value="DELETE">Apagar</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>

                        {/* 3) Quando falhar */}
                        <Box sx={{ mt: 2 }}>
                            <MuiTypography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
                                Quando o disparo falhar:
                            </MuiTypography>
                            <FormControl size="small" fullWidth sx={{ mt: 1.5 }}>
                                <InputLabel id="reaction-failed">Ação</InputLabel>
                                <Select
                                    labelId="reaction-failed"
                                    label="Ação"
                                    value={getSelectValue(reactions.failed)}
                                    onChange={({ target }) => {
                                        const nextReactions = ensureReactionsShape(parent.reactions)
                                        nextReactions.failed = applySelectValue(target.value, nextReactions.failed)
                                        setParent({ reactions: nextReactions })
                                    }}
                                >
                                    <MenuItem value="NONE">Nenhuma ação</MenuItem>
                                    <Divider />
                                    {availableColumns.map(col => (
                                        <MenuItem key={col.id} value={String(col.id)}>{col.title}</MenuItem>
                                    ))}
                                    <Divider />
                                    <MenuItem value="ARCHIVE">Arquivar</MenuItem>
                                    <MenuItem value="DELETE">Apagar</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>
                )}

                {showVoiceReactions && (
                    <Box sx={{ mt: 1 }}>
                        <Divider sx={{ mb: 1 }} />
                        <MuiTypography variant="h6" gutterBottom className="typography-title">
                            Reações ao resultado da ligação
                        </MuiTypography>

                        {VOICE_REACTION_OUTCOMES.map(({ key, label }) => (
                            <Box sx={{ mt: 2 }} key={key}>
                                <MuiTypography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    Quando {label.toLowerCase()}:
                                </MuiTypography>
                                <FormControl size="small" fullWidth sx={{ mt: 1 }}>
                                    <InputLabel id={`voice-reaction-${key}`}>Ação</InputLabel>
                                    <Select
                                        labelId={`voice-reaction-${key}`}
                                        label="Ação"
                                        value={getSelectValue(voiceReactions[key])}
                                        onChange={({ target }) => {
                                            const next = ensureVoiceReactionsShape(parent.reactions)
                                            next[key] = applySelectValue(target.value, next[key])
                                            setParent({ reactions: next })
                                        }}
                                    >
                                        <MenuItem value="NONE">Nenhuma ação</MenuItem>
                                        <Divider />
                                        {availableColumns.map(col => (
                                            <MenuItem key={col.id} value={String(col.id)}>{col.title}</MenuItem>
                                        ))}
                                        <Divider />
                                        <MenuItem value="ARCHIVE">Arquivar</MenuItem>
                                        <MenuItem value="DELETE">Apagar</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        ))}
                    </Box>
                )}

            </Box>
        </>
    )
}

export const AutomationType = ({ parent, setParent, botList, setBotList }) => {

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const initialize = async () => {
            setLoading(true)
            const res = await api.get(`/api/getBuilder/?trimmed=true`)
            if (res.status === 200) {
                setBotList(res.data.botlist.sort((x, y) => alphabeticalSort(x, y, 'name')))
            }
            setLoading(false)
        };
        if (!botList)
            initialize()

    }, [])

    return (
        <>
            <Loading loading={loading} />
            <FormControl size='small' fullWidth>
                <InputLabel id='select-flux-data'>Fluxo</InputLabel>
                <Select
                    labelId='select-flux-data'
                    label='Fluxo'
                    value={parent.bot}
                    onChange={({ target }) => {
                        setParent({ bot: target.value })
                    }}
                >
                    {(botList || []).flatMap(bot => {
                        return (<MenuItem value={bot.id}>{bot.name}</MenuItem>)
                    }
                    )}
                </Select>
            </FormControl>
            <Alert severity='info' sx={{maxHeight: '20rem', overflow: 'auto'}}>
                <pre style={{whiteSpace: 'pre-line', fontSize: '.8em'}}>
                <span style={{fontWeight:'bold'}}>Variáveis que podem ser utilizadas no bot:</span>
                <br></br><br></br>
                <span style={{fontWeight:'bold'}}>opportunity_id:</span> Id da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_contact:</span> Nome do contato da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_owner_name:</span> Nome do vendedor da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_owner_id:</span> ID do vendedor da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_journey_id:</span> ID da jornada da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_title:</span> Nome da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_description:</span> Descrição da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_value:</span> Valor da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_estimated_at:</span> Data estimata da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_closed_at:</span> Data de fechamendo da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_status:</span> Status da oportunidade<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_archived:</span> Se a oportunidade está arquivada<br></br>
                <span style={{fontWeight:'bold'}}>opportunity_column:</span> Coluna da oportunidade<br></br>
                <br></br><br></br>
                <span style={{fontWeight:'bold'}}>As variáveis de contato abaixo, só existem se o contato for definido.</span>
                <br></br><br></br>
                <span style={{fontWeight:'bold'}}>contact_id:</span> Id do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_groups:</span> Segmentos do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_enterprise_groups:</span> Segmentos da empresa do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_nick:</span> Nick do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_custom_fields:</span> Campos customizados do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_telephone:</span> Telefone do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_name:</span> Nome do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_email:</span> Email do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_enterprise:</span> Id da empresa do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_enterprise_name:</span> Nome da empresa do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_internal_code:</span> Código interno do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_birthday:</span> Aniversário do contato<br></br>
                <span style={{fontWeight:'bold'}}>contact_created_at:</span> Data de criação do contato<br></br>
                </pre>
            </Alert>
        </>
    )
}

export const EditType = ({ columnId, parent, setParent }) => {
    const { board } = useContext(JourneyContext)

    const enterpriseId = getSession().profile.enterprise.id

    const [journeys, setJourneys] = useState([])
    const [targetJourney, setTargetJourney] = useState(null) // detalhe (com columns)
    const [loading, setLoading] = useState(false)

    const action = parent.action

    // "" => mesma jornada | number => outra jornada
    const targetJourneyId = parent.target_journey_id ?? ""
    const destination = parent.destination ?? ""

    const defaultCopyOptions = {
        description: true,
        value_currency: true,
        contact: true,
        contact_enterprise: true,
        owner: true,
        tags: true,
        estimated_at: true,
        closed_at: true,
        secondary_contacts: true,
        custom_fields: true,
    }

    const copyOptions = parent.copy_options || defaultCopyOptions
    const copyHistory = parent.copy_history ?? true

    const markAll = () => {
        const allTrue = Object.fromEntries(Object.keys(defaultCopyOptions).map(k => [k, true]))
        setParent({ copy_options: allTrue })
    }

    const unmarkAll = () => {
        const allFalse = Object.fromEntries(Object.keys(defaultCopyOptions).map(k => [k, false]))
        setParent({ copy_options: allFalse })
    }

    // carrega lista de jornadas quando for MOVE/COPY
    useEffect(() => {
        if (!['MOVE', 'COPY'].includes(action)) return

        const loadJourneys = async () => {
            setLoading(true)
            try {
                const res = await api.get(`api/enterprises/${enterpriseId}/journeys/`)
                console.log("JourneyList", res)
                if (res.status === 200) {
                    const list = res.data.results || res.data
                    setJourneys(Array.isArray(list) ? list : [])
                }
            } finally {
                setLoading(false)
            }
        }

        loadJourneys()
    }, [action, enterpriseId])

    // quando selecionar uma jornada destino, carrega o detalhe (pra ter columns)
    useEffect(() => {
        if (!['MOVE', 'COPY'].includes(action)) return

        const loadTargetJourney = async () => {
            if (!targetJourneyId || targetJourneyId === "same" || targetJourneyId === null) {
                setTargetJourney(null)
                return
            }

            setLoading(true)
            try {
                const res = await api.get(`api/enterprises/${enterpriseId}/journeys/${targetJourneyId}/`)
                if (res.status === 200) setTargetJourney(res.data)
            } finally {
                setLoading(false)
            }
        }

        loadTargetJourney()
    }, [action, targetJourneyId, enterpriseId])

    // colunas disponíveis conforme jornada destino
    const columnsForSelectedJourney = useMemo(() => {
        if (targetJourneyId === "same" || targetJourneyId === "" || targetJourneyId === null) {
            return (board?.columns || []).filter(c => c.id !== columnId)
        }
        return (targetJourney?.columns || [])
    }, [targetJourneyId, targetJourney, board?.columns, columnId])

    const showDestination = action === 'MOVE' || action === 'COPY'
    const showCopyOptions = action === 'COPY'
    const showStatus = action === 'STATUS'

    return (
        <>
            <Loading loading={loading} />

            <FormControl size='small' fullWidth>
                <InputLabel id='select-action-data'>Ação</InputLabel>
                <Select
                    labelId='select-action-data'
                    label='Ação'
                    value={parent.action}
                    onChange={({ target }) => {
                        const next = target.value
                        const reset = {
                            action: next,
                            target_journey_id: "",
                            destination: "",
                        }
                        if (next === 'COPY') {
                            reset.copy_options = defaultCopyOptions
                            reset.copy_history = true
                        }
                        setTargetJourney(null)
                        setParent(reset)
                    }}
                >
                    {Object.entries(EditOptions).flatMap(([key, value]) => {
                        if (key === '') return []
                        return (<MenuItem key={key} value={key}>{value}</MenuItem>)
                    })}
                </Select>
            </FormControl>

            {showDestination && (
                <>
                    <FormControl size='small' fullWidth>
                        <InputLabel id='select-target-journey'>Jornada de destino</InputLabel>
                        <Select
                            labelId='select-target-journey'
                            label='Jornada de destino'
                            value={
                                targetJourneyId === "" ||
                                targetJourneyId === null ||
                                targetJourneyId === "same"
                                    ? "same"
                                    : targetJourneyId
                            }
                            displayEmpty
                            renderValue={(selected) => {
                                if (selected === "" && targetJourneyId === null) return ""
                                if (selected === "same") return "Mesma jornada"
                                const journey = (journeys || []).find(j => j.id === selected)
                                return journey?.name || ""
                            }}
                            onChange={({ target }) => {
                                const raw = target.value
                                const nextId = raw === "same" ? "" : Number(raw)
                                setTargetJourney(null)
                                setParent({ target_journey_id: nextId, destination: "" })
                            }}
                        >
                            <MenuItem value="same">Mesma jornada</MenuItem>
                            <Divider />
                            {(journeys || []).map(j => (
                                <MenuItem key={j.id} value={j.id}>{j.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl size='small' fullWidth disabled={columnsForSelectedJourney.length === 0}>
                        <InputLabel id='select-destination-data'>Coluna de destino</InputLabel>
                        <Select
                            labelId='select-destination-data'
                            label='Coluna de destino'
                            value={destination}
                            onChange={({ target }) => {
                                const raw = target.value
                                const nextCol = raw === "" ? "" : Number(raw)
                                setParent({ destination: nextCol })
                            }}
                        >
                            {columnsForSelectedJourney.map(col => (
                                <MenuItem key={col.id} value={col.id}>{col.title}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </>
            )}

            {showStatus && (
                <FormControl size='small' fullWidth>
                    <InputLabel id='select-status-data'>Status</InputLabel>
                    <Select
                        labelId='select-status-data'
                        label='Status'
                        value={parent.status || ''}
                        onChange={({ target }) => {
                            setParent({ status: target.value })
                        }}
                    >
                        {Object.entries(StatusOptions).map(([key, value]) => (
                            <MenuItem key={key} value={key}>{value}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}

            {showCopyOptions && (
                <Box sx={{ mt: 1 }}>
                    <Divider sx={{ mb: 1 }} />
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                        <Typography variant="subtitle2">O que copiar</Typography>
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <Button size="small" onClick={markAll}>Marcar todos</Button>
                            <Button size="small" onClick={unmarkAll}>Desmarcar todos</Button>
                        </Box>
                    </Box>

                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.description}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, description: e.target.checked } })
                                    }
                                />
                            }
                            label="Descrição"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.value_currency}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, value_currency: e.target.checked } })
                                    }
                                />
                            }
                            label="Valor e moeda"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.owner}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, owner: e.target.checked } })
                                    }
                                />
                            }
                            label="Vendedor"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.contact_enterprise}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, contact_enterprise: e.target.checked } })
                                    }
                                />
                            }
                            label="Empresa"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.contact}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, contact: e.target.checked } })
                                    }
                                />
                            }
                            label="Contato"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.secondary_contacts}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, secondary_contacts: e.target.checked } })
                                    }
                                />
                            }
                            label="Outros contatos"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.estimated_at}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, estimated_at: e.target.checked } })
                                    }
                                />
                            }
                            label="Estimada para"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.closed_at}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, closed_at: e.target.checked } })
                                    }
                                />
                            }
                            label="Fechada em"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.tags}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, tags: e.target.checked } })
                                    }
                                />
                            }
                            label="Marcadores"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyOptions.custom_fields}
                                    onChange={(e) =>
                                        setParent({ copy_options: { ...copyOptions, custom_fields: e.target.checked } })
                                    }
                                />
                            }
                            label="Campos personalizados"
                        />

                        <Divider sx={{ my: 1 }} />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!!copyHistory}
                                    onChange={(e) => setParent({ copy_history: e.target.checked })}
                                />
                            }
                            label="Copiar histórico"
                        />
                    </FormGroup>
                </Box>
            )}
        </>
    )
}
